import UserDisplayName, { type UserDisplayNameProps } from '@creator/ui/components/UserDisplayName/UserDisplayName';
import { mergeProps } from '@creator/ui/utils/merge-props/merge-props';
import { capitalizeFirstLetter } from '@creator/ui/utils/string';
import { ensureTokenUrl } from '@src/model/config/helpers';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import type { FC } from 'react';
import { memo } from 'react';
import { Link, type LinkProps } from 'react-router';

export interface UserDisplayNameWithLinkProps {
    className?: string;
    tokenName: string;
    displayName: string;
    slugUrl?: string;
    profileName?: string;
    userDisplayNameProps?: Omit<UserDisplayNameProps, 'displayName'>;
    linkProps?: Partial<LinkProps>;
}

const UserDisplayNameWithLink: FC<UserDisplayNameWithLinkProps> = props => {
    const { userDisplayNameProps = {}, tokenName, displayName, profileName, slugUrl } = props;

    function renderContent() {
        const { linkProps = {} } = props;

        if (displayName === 'anonymous') return <UserDisplayName displayName={capitalizeFirstLetter(displayName)} {...userDisplayNameProps} />;

        const _linkProps = mergeProps(
            {
                className: 'link',
                to: `/${ensureTokenUrl(tokenName)}/author/${slugUrl || displayName}`,
                onClick: e => e.stopPropagation(),
            },
            linkProps
        );

        return (
            <Link data-ssr="author-link" {..._linkProps}>
                {renderUserDisplayName()}
            </Link>
        );
    }

    function renderUserDisplayName() {
        const _props = mergeProps<[UserDisplayNameProps, Partial<UserDisplayNameProps>]>(
            {
                displayName: profileName || displayName,
            },
            userDisplayNameProps
        );
        return <UserDisplayName {..._props} />;
    }

    return renderContent();
};

export default memo(UserDisplayNameWithLink, propsEqualityFn);
